import { Box, Flex, Avatar } from "@chakra-ui/react";

export default function DsrUserProfilePanelDisplay({ userProfile }) {
  const { userName, userProfilePicSrc, userPosition, sellerOrganisationName } = userProfile || {};

  return (
    <>
      <Flex align='flex-start' mt='1em'>
        {userProfilePicSrc && 
        <Flex as='span' px='0.5em'>
          <Avatar h='4.2em' w='4.2em' name={userName} bg='gray.100' color='gray.700' src={userProfilePicSrc} />
        </Flex>
        }

        <Flex className="white-space-preline">
          <Box fontWeight='600' fontSize='0.875em' lineHeight='1.25em' color='white'>
            {userName}
          
              <Box fontSize='0.8em' lineHeight='1em' fontWeight='400' color='gray.50' mt='2px'>
                {userPosition} {sellerOrganisationName ? `@ ${sellerOrganisationName}` : ""}
              </Box>
           
          </Box>
        </Flex>
      </Flex>
    </>
  );
}
